/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_Event_Groups_LabelInputs */

const en_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Event Groups`)
};

const fr_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionner les groupes d’événements`)
};

const de_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisgruppen auswählen`)
};

const it_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona gruppi di eventi`)
};

const ru_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группы мероприятий`)
};

const es_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar grupos de eventos`)
};

const zh_cn2_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择活动组`)
};

const ja_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループを選択`)
};

const hi_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह चुनें`)
};

const pt_pt2_batch_subtitle_export_event_groups_label = /** @type {(inputs: Batch_Subtitle_Export_Event_Groups_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecionar grupos de eventos`)
};

/**
* | output |
* | --- |
* | "Select Event Groups" |
*
* @param {Batch_Subtitle_Export_Event_Groups_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_event_groups_label = /** @type {((inputs?: Batch_Subtitle_Export_Event_Groups_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_Event_Groups_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "de") return de_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "it") return it_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "ru") return ru_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "es") return es_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "zh-CN") return zh_cn2_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "ja") return ja_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "hi") return hi_batch_subtitle_export_event_groups_label(inputs)
	if (locale === "pt-PT") return pt_pt2_batch_subtitle_export_event_groups_label(inputs)
	return en_batch_subtitle_export_event_groups_label(inputs)
});